module.exports = __webpack_public_path__ + "img/9788974833763.64ed40ed.jpg";